import styled from '@emotion/styled'

const S = {}

S.Button = styled.button`
  cursor: pointer;
  border: none;
  background: transparent;
  width: 3.75rem;
  height: 1.25rem;
  box-sizing: border-box;
  font-size: 0;
  line-height: 0;
  padding: 0.5rem 0.3125rem;

  &:focus {
    outline: 0.125rem solid transparent;
    outline-offset: 0.125rem;
    box-shadow: 0 0 0 0.25rem rgba(160, 160, 160, 0.75) inset;

    .bar {
      background-color: white;
      transform: scaleY(1);
    }

    .slick-active & {
      .bar {
        background-color: rgba(255, 255, 255, 0.5);
      }
    }
  }

  @media (hover: hover) {
    &:hover {
      .bar {
        background-color: white;
        transform: scaleY(1);
      }

      .slick-active & {
        .bar {
          background-color: rgba(255, 255, 255, 0.5);
        }
      }
    }
  }

  .bar {
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.5);
    transform: scaleY(0.5);
    transition: 0.15s ease;
    transition-property: transform, background-color;
  }
`

export default S
